<template>
  <q-card flat bordered class="row justify-between" v-if="trendFilterData">
    <div class="col-lg-12 col-12 q-mt-x">
      <div class="q-ma-sm text-center q-ml-md">
        <span class="text-subtitle1 text-secondary text-bold">
          <span class="text-bold"> {{ title }} </span>
        </span>
      </div>
      <div class="q-mx-xs q-pa-xs-xs">
        <q-separator />
        <div v-if="trendFilterData">
          <div>
            <q-list
              bordered
              separator
              class="text-subtitle2 q-pa-none q-ma-none"
            >
              <q-item>
                <q-item-section>Very Short Term</q-item-section>

                <q-separator vertical></q-separator>

                <q-item-section
                  class="text-left q-ml-lg q-px-md"
                  :class="backgroundClass(trendFilterData.trend_7_days)"
                >
                  {{ trendFilterData.trend_7_days }}
                </q-item-section>
              </q-item>
              <q-item>
                <q-item-section>Short Term</q-item-section>

                <q-separator vertical></q-separator>

                <q-item-section
                  class="text-left q-ml-lg q-px-md"
                  :class="backgroundClass(trendFilterData.trend_21_days)"
                >
                  {{ trendFilterData.trend_21_days }}
                </q-item-section>
              </q-item>
              <q-item>
                <q-item-section>Mid Term</q-item-section>

                <q-separator vertical></q-separator>

                <q-item-section
                  class="text-left q-ml-lg q-px-md"
                  :class="backgroundClass(trendFilterData.trend_50_days)"
                >
                  {{ trendFilterData.trend_50_days }}
                </q-item-section>
              </q-item>
              <q-item>
                <q-item-section>Long Term</q-item-section>

                <q-separator vertical></q-separator>

                <q-item-section
                  class="text-left q-ml-lg q-px-md"
                  :class="backgroundClass(trendFilterData.trend_200_days)"
                >
                  {{ trendFilterData.trend_200_days }}
                </q-item-section>
              </q-item>
            </q-list>
          </div>
        </div>
        <div v-else>
          <p>No Signals Found</p>
        </div>
      </div>
    </div>
  </q-card>
</template>
<script setup>
import { ref } from "vue";
import { useQuasar } from "quasar";
const title = ref("Technical Status");
const $q = useQuasar();

const props = defineProps({
  trendFilterData: {
    type: Object,
    default: () => {},
  },
});

const backgroundClass = (p) => {
  if (p === "Uptrend") {
    return $q.dark.mode ? "bg-green-4" : "bg-green-2";
  } else if (p === "Downtrend") {
    return $q.dark.mode ? "bg-red-4" : "bg-red-2";
  } else if (p == "Sideways") {
    return $q.dark.mode ? "bg-blue-4" : "bg-blue-2";
  } else {
    return "grey";
  }
};
</script>
